/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */

/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { API_URL } from "utils/constant";
import httpClient from "utils/apis/http-client";
import { isOperationAllowed, showToast } from "utils/helper";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Input,
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { useGetAllAssets } from "utils/apis/assets.api";
import { PencilIcon, ViewIcon } from "lucide-react";
import AddAssetCard from "./add-asset-card";
import EditAssetCard from "./asset-edit-card";
import AssetDetailsCard from "./asset-details-card";
import AssetsIssuance from "./asset-issurance";
import AssetsReturn from "./assets-return";
import { formatDate } from "date-fns";
import { Permissions } from "utils/enums";

const apiUrl = API_URL;

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

function AssetsManagement() {
  const [dataState, setDataState] = useState<any>(initialDataState);
  const [asset, setAsset] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");

  const [showAddModel, setShowAddModel] = useState(false);
  const [showDetailsModel, setShowDetailsModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showIssuanceModel, setShowIssuanceModel] = useState(false);
  const [showReturnModel, setShowReturnModel] = useState(false);

  const pageSize = 20;

  const { data: assetsData, isPending: isLoading } = useGetAllAssets({
    pageNumber: currentPage,
    pageRowCount: pageSize,
    searchCriteria: filter.length >= 3 ? filter : "",
    operationDate: formatDate(new Date(), "yyyy-MM-dd'T'00:00:00.000'Z'"),
    cashCenterId: "",
    customerId: "",
  });

  const toggleIssuanceModel = () => {
    setShowIssuanceModel(!showIssuanceModel);
  };

  const toggleReturnModel = () => {
    setShowReturnModel(!showReturnModel);
  };

  const toggleAddModel = () => {
    setShowAddModel(!showAddModel);
  };

  const toggleDetailsModel = () => {
    setShowDetailsModel(!showDetailsModel);
  };

  const toggleEditModel = () => {
    setShowEditModel(!showEditModel);
  };

  const onAssetAdded = () => {
    toggleAddModel();
  };

  const onAssetUpdated = () => {
    setAsset(null);
    toggleEditModel();
  };

  function DetailsButtonCell({ dataItem }: any) {
    const onClick = async () => {
      const { assetId } = dataItem;

      const assetEndpoint = `${apiUrl}/resources/assets/${assetId}`;

      try {
        await httpClient.get(assetEndpoint).then((res) => {
          if (res.status === 200) {
            setAsset(res.data);
            toggleDetailsModel();
          } else {
            setAsset(null);
            showToast("error", "Unable to load asset details.");
          }
        });
      } catch (error) {
        setAsset(null);
        showToast("error", "Unable to load asset details.");
      }
    };

    return (
      <td className="text-center mt-3">
        <Button variant="secondary" className="w-full p-2" onClick={onClick}>
          <ViewIcon />
        </Button>
      </td>
    );
  }

  function EditButtonCell({ dataItem }: any) {
    const onClick = async () => {
      const { assetId } = dataItem;

      const assetEndpoint = `${apiUrl}/resources/assets/${assetId}`;

      try {
        await httpClient.get(assetEndpoint).then((res) => {
          if (res.status === 200) {
            setAsset(res.data);
            toggleEditModel();
          } else {
            setAsset(null);
            showToast("error", "Unable to load asset details.");
          }
        });
      } catch (error) {
        setAsset(null);
        showToast("error", "Unable to load asset details.");
      }
    };

    return (
      <td className="text-center mt-3">
        <Button variant="secondary" className="w-full p-2" onClick={onClick}>
          <PencilIcon />
        </Button>
      </td>
    );
  }

  const onAssetsIssued = () => {
    toggleIssuanceModel();
  };

  const onAssetsReturned = () => {
    toggleReturnModel();
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };
  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };

  const onFilterSearch = (e: any) => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
    setFilter(e.target.value as string);
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Assets Management</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-4">
              {isOperationAllowed(Permissions.Asset, Permissions.Search) ? (
                <Input
                  placeholder="Search: Description, Asset Type, Asset No, Issued To, Route No"
                  title="Description, Asset Type, Asset No, Issued To, Route No"
                  value={filter}
                  className="max-w-[360px] w-full mr-auto"
                  onChange={onFilterSearch}
                />
              ) : null}
              {isOperationAllowed(Permissions.Asset, Permissions.Edit) ? (
                <Button variant="secondary" onClick={toggleIssuanceModel}>
                  Issue Assets
                </Button>
              ) : null}
              {isOperationAllowed(Permissions.Asset, Permissions.Edit) ? (
                <Button variant="secondary" onClick={toggleReturnModel}>
                  Return Assets
                </Button>
              ) : null}
              {isOperationAllowed(Permissions.Asset, Permissions.Add) ? (
                <Button variant="secondary" onClick={toggleAddModel}>
                  Add New Asset
                </Button>
              ) : null}
            </div>

            <div className="border-b my-3 bg-accent" />

            <div className="flex">
              <div className="w-full">
                {isLoading ? (
                  loadingPanel
                ) : (
                  <Grid
                    data={process(assetsData?.data || [], {
                      ...dataState,
                      skip: 0,
                    })}
                    {...dataState}
                    onDataStateChange={onDataStateChange}
                    onPageChange={onPageChange}
                    filterable
                    sortable
                    pageable
                    pageSize={pageSize}
                    total={assetsData?.totalRecords}
                    skip={(currentPage - 1) * pageSize}
                  >
                    <Column
                      field="cashCenter"
                      width={180}
                      title="Cash Center"
                    />

                    <Column field="office" width={180} title="Office" />

                    <Column
                      field="description"
                      width="140"
                      title="Description"
                    />

                    <Column field="assetType" width="140" title="Asset Type" />

                    <Column field="assetNo" width="140" title="Asset No" />

                    <Column field="serialNo" width="140" title="Serial" />

                    <Column field="employeeId" width="140" title="Issued To" />

                    <Column
                      field="issuedDate"
                      width="140"
                      title="Issued Date"
                    />

                    <Column field="issuedBy" width="140" title="Issued By" />

                    <Column
                      field="returnedDate"
                      width="140"
                      title="Returned Date"
                    />

                    <Column
                      field="receivedBy"
                      width="140"
                      title="Received By"
                    />

                    <Column field="routeNo" width="140" title="Route No" />

                    <Column field="status" width="140" title="Status" />

                    <Column field="remarks" width={180} title="Remarks" />

                    <Column
                      width="80"
                      title="View"
                      className="text-center"
                      filterable={false}
                      cell={DetailsButtonCell}
                    />

                    <Column
                      width="80"
                      title="Edit"
                      className="text-center"
                      filterable={false}
                      cell={EditButtonCell}
                    />
                  </Grid>
                )}
              </div>
            </div>
            <Dialog open={showAddModel} onOpenChange={toggleAddModel}>
              <DialogContent className="max-w-[950px]">
                <DialogHeader>
                  <DialogTitle>Add Asset</DialogTitle>
                </DialogHeader>
                <DialogDescription>
                  <AddAssetCard onAssetAdded={onAssetAdded} />
                </DialogDescription>
              </DialogContent>
            </Dialog>
            <Dialog open={showDetailsModel} onOpenChange={toggleDetailsModel}>
              <DialogContent className="max-w-[950px]">
                <DialogHeader>
                  <DialogTitle>Asset Details</DialogTitle>
                </DialogHeader>
                <DialogDescription>
                  {asset ? <AssetDetailsCard asset={asset} /> : null}
                </DialogDescription>
              </DialogContent>
            </Dialog>

            <Dialog open={showEditModel} onOpenChange={toggleEditModel}>
              <DialogContent className="max-w-[950px]">
                <DialogHeader>
                  <DialogTitle>Update Asset</DialogTitle>
                </DialogHeader>
                <DialogDescription>
                  {asset ? (
                    <EditAssetCard
                      asset={asset}
                      onAssetUpdated={onAssetUpdated}
                    />
                  ) : null}
                </DialogDescription>
              </DialogContent>
            </Dialog>
            <Dialog open={showIssuanceModel} onOpenChange={toggleIssuanceModel}>
              <DialogContent className="max-w-[950px]">
                <DialogHeader>
                  <DialogTitle>Issue Assets</DialogTitle>
                </DialogHeader>
                <DialogDescription>
                  <AssetsIssuance onAssetIssued={onAssetsIssued} />
                </DialogDescription>
              </DialogContent>
            </Dialog>
            <Dialog open={showReturnModel} onOpenChange={toggleReturnModel}>
              <DialogContent className="max-w-[950px]">
                <DialogHeader>
                  <DialogTitle>Return Asset</DialogTitle>
                </DialogHeader>
                <DialogDescription>
                  <AssetsReturn onAssetReturned={onAssetsReturned} />
                </DialogDescription>
              </DialogContent>
            </Dialog>
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}

export default AssetsManagement;

const loadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image" />
    <div className="k-loading-color" />
  </div>
);
